import React from 'react';
import ReactDOM from 'react-dom/client';
import App from './App.jsx';
import "./Styles/bootstrap.css";
import "./Styles/font-awesome.css";
import './Styles/index.css';
import './Styles/animate.css';

const root = ReactDOM.createRoot(document.getElementById("root"));
root.render(
  <React.StrictMode>
    <App />
  </React.StrictMode>
);
